<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2> 
        </div>
        <div class="row col-md-12 align-items-center mt-2" v-if="listaReportes?.length != 0">             <div class="col-md-12 d-flex justify-content-end">
                <b-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="creaReporte">
                    <i class="fa-solid fa-plus"></i>
                </b-button>
            </div>
            <div class="row col-md-12 justify-content-center">
                <b-table md-card md-fixed-header>
                    <b-table-row slot="b-table-row" slot-scope="{ item }">
                        <b-table-cell :md-label="labels.numero" class="border">{{ item?.codigo }}</b-table-cell> 
                        <b-table-cell :md-label="labels.name" class="text-left border">{{ item?.nombre }}</b-table-cell> 
                        <b-table-cell :md-label="labels.principal" class="text-left border">{{item?.principal }}</b-table-cell> 
                        <b-table-cell :md-label="labels.libro_notas" class="text-left border">{{item?.libro_notas }}</b-table-cell> 
                        <b-table-cell :md-label="labels.edit" class="border"> 
                            <b-button style="background-color: #e5ac00; width: 30px; height: 30px;" class="md-fab md-primary" @click="editReporte(item)">
                                <i>edit</i>
                            </b-button>
                        </b-table-cell>
                        <b-table-cell :md-label="labels.delete" class="border"> 
                            <b-button style="background-color: #cd2838; width: 30px; height: 30px;" class="md-fab md-primary" @click="deleteReporte(item.id)"> 
                                <i>delete</i>
                            </b-button>
                        </b-table-cell>
                    </b-table-row>
                </b-table>
            </div>
        </div>
        <div v-else>
            <h4 class="mt-4">{{ labels.noData }}</h4> 
            <div class="mt-4">
                <b-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="creaReporte">
                    <i class="fa-solid fa-plus"></i>
                </b-button>
            </div>
        </div>
        <CreaReporte :modCreaReporte="modCreaReporte" @refrescaTbl="reloadTbl" @closeModal="cierraModal"/>
        <EditaReporte :modEditaReporte="modEditaReporte" :ItemReport="infoReporte" @refrescaTbl="reloadTbl" @closeModal="cierraModal"/>
        <InacticaItem :InactivaItem="deletFila" @confirmDelete="confirmDel" @cierraModal="closeMod"/>
    </div>
</template>
<script>
import TipoReporte from '../../../services/TipoReporte' 
import CreaReporte from './CreaReporte.vue' 
import EditaReporte from './EditaReporte.vue' 
import InacticaItem from '../../utils/InacticaItem.vue' 
export default {
    name:'TipoReporte',
    components:{CreaReporte,EditaReporte,InacticaItem},
    data:() => ({
        showTblReportes : false,
        listaReportes : [],
        modCreaReporte : false,
        modEditaReporte : false,
        infoReporte : {},
        idReportDel : null,
        deletFila : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Reportes',
                    numero : 'Número',
                    name : 'Nombre',
                    libro_notas : 'Libro Notas',
                    edit : 'Editar',
                    delete : 'Eliminar',
                    noData : 'No hay datos',
                    principal: "Principal"
                }
            }else{
                return {
                    title : 'Reports',
                    numero : 'Number',
                    name : 'Name',
                    libro_notas : 'Notes',
                    edit : 'Edit',
                    delete : 'Eliminar',
                    noData : 'No hay datos',
                    principal: "Main"
                }
            }
        }
    },
    methods:{
        cierraModal(valor){
            this.modCreaReporte = valor
            this.modEditaReporte = valor
        },
        closeMod(valor){
            this.deletFila = valor
        },
        creaReporte(){
            // console.log('creaReporte'); 
            this.modCreaReporte = true
        },
        async editReporte(item){
            console.log('editaId:',item); 
            this.infoReporte = item
            this.modEditaReporte = true
        },
        deleteReporte(id){
            // console.log('deleteId:',id); 
            this.idReportDel = id
            this.deletFila = true
        },
        confirmDel(){
            
            TipoReporte.deleteReporte(this.idReportDel)
            .then((res) => { 
                this.$toast.success(res.data.message)
                this.reloadTbl()
                this.deletFila = false
            })
            .catch((err) => console.log(err)) 
        },
        reloadTbl(){
  console.log("reload") 
            TipoReporte.getAllTipoReporte() 
            .then((res) => { 
                // console.log(res); 
                this.listaReportes = res.data.typeReport
                this.modCreaReporte = false
                this.modEditaReporte = false
            })
            .catch((err) => console.log(err)) 
        }
    },
    mounted(){
        TipoReporte.getAllTipoReporte() 
        .then((res) => { 
            // console.log(res); 
            this.listaReportes = res.data.typeReport
        })
        .catch((err) => console.log(err)) 
    }
}
</script>
<style>
</style>
